import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from '../../../../core/services/language.service';
import { PricingRow } from '../../../models/interfaces/pricing.interface';

@Component({
  selector: 'app-pricing-features-table-row',
  templateUrl: './pricing-features-table-row.component.html',
  styleUrls: ['./pricing-features-table-row.component.scss'],
})
export class PricingFeaturesTableRowComponent implements OnInit {
  @Input() row: PricingRow;

  constructor(public languageService: LanguageService) {}

  ngOnInit(): void {}
}
